import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

function ScrollToTop (props: any): JSX.Element {
 const location = useLocation()
  useEffect(() => {
    if (location.hash.length === 0) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto'
      })
    }
  }, [location])

  return <>{props.children}</>
}

export default ScrollToTop
